import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

// material-ui
import Alert from '@mui/material/Alert';

// project-imports
import { captureError } from 'errorTracking';

// ==============================|| ELEMENT ERROR - COMMON ||============================== //

export default function ErrorBoundary() {
  const error = useRouteError();

  // Report the error this boundary is about to render (OBS-01). A route error response — a thrown
  // Response — is a routing outcome, not a defect, and is not reported. The alerts below are unchanged.
  useEffect(() => {
    if (!isRouteErrorResponse(error)) {
      captureError(error, { route: window.location.pathname });
    }
  }, [error]);

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <Alert severity="error">Error 404 - This page doesn&apos;t exist!</Alert>;
    }

    if (error.status === 401) {
      return <Alert severity="error">Error 401 - You aren&apos;t authorized to see this</Alert>;
    }

    if (error.status === 503) {
      return <Alert severity="error">Error 503 - Looks like our API is down</Alert>;
    }

    if (error.status === 418) {
      return <Alert severity="error">Error 418 - Contact administrator</Alert>;
    }
  }

  return <Alert severity="error">Under Maintenance</Alert>;
}
